<template>
  <div data-v-63c64df2="" data-v-2ac6a5fc="" class="deposit-container" style="min-height: 100vh; height: 100%; padding-bottom: 150px">
    <div class="deposit-box">
      <van-grid :border="false" :column-num="4">
        <van-grid-item v-for="(item, index) in payWayList" :key="index" @click="changeTab(item, index)">
          <div class="rechargeType" :class="indexTab == index ? 'rechargeType-selected' : ''">
            <div class="gift_info" v-if="item.gift_info && item.gift_info.length > 0">{{ item.gift_info }}</div>
            <img :src="item.logo" />
            <p>{{ item.name }}</p>
            <span>{{ item.min_price }} - {{ item.max_price }}</span>
            <div class="selected" v-if="indexTab == index">
              <svg width="24" height="24" viewBox="0 0 32 32" class="h-5 w-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 16.5L32 0V22C32 27.5228 27.5228 32 22 32H0L15 16.5Z" fill="#cca352"></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.2438 17.0091C26.4403 17.1401 26.5767 17.3438 26.623 17.5754C26.6693 17.807 26.6218 18.0475 26.4908 18.2441L20.5533 27.1503C20.4801 27.2598 20.3836 27.3518 20.2707 27.4195C20.1577 27.4873 20.0312 27.5292 19.9001 27.5421C19.769 27.555 19.6367 27.5388 19.5127 27.4944C19.3887 27.4501 19.276 27.3788 19.1829 27.2857L15.6204 23.7232C15.4631 23.5543 15.3774 23.331 15.3815 23.1003C15.3856 22.8696 15.479 22.6494 15.6422 22.4862C15.8054 22.3231 16.0255 22.2296 16.2563 22.2255C16.487 22.2215 16.7103 22.3071 16.8791 22.4644L19.6733 25.2586L25.0088 17.2549C25.14 17.0585 25.3438 16.9224 25.5754 16.8763C25.807 16.8302 26.0474 16.8779 26.2438 17.0091Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <div class="recharge_desc" v-if="payWay">
        {{ payWay.recharge_desc }}
      </div>
    </div>
    <div class="deposit-aisle" v-if="rechargeAisle && rechargeAisle.length > 0">
      <div class="title">
        充值方式
        <div class="loaddown" v-if="(payWay && payWay.download_url && payWay.download_url.length > 0)">
          <a href="payWay.download_url" target="_bank" style="color: rgb(194, 187, 198); text-decoration: underline"> <van-icon name="down" color="#cca352" />{{ payWay.name }}下载地址 </a>
        </div>
      </div>
      <div class="deposit-aisle-box">
        <ul>
          <div v-for="(item, index) in rechargeAisle" :key="index">
            <li @click="changeAisle(item, index)" class="aisle-item" :class="indexAisle == index ? 'aisle-item-select' : ''" v-show="index <= 3 || showMore">
              <div class="icon">
                <img :src="payWay.logo" style="width: 24px; height: 24px" />
              </div>
              <div class="name">{{ item.name }}</div>
              <div class="selected" v-if="indexAisle == index">
                <svg width="24" height="24" viewBox="0 0 32 32" class="h-5 w-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 16.5L32 0V22C32 27.5228 27.5228 32 22 32H0L15 16.5Z" fill="#cca352"></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.2438 17.0091C26.4403 17.1401 26.5767 17.3438 26.623 17.5754C26.6693 17.807 26.6218 18.0475 26.4908 18.2441L20.5533 27.1503C20.4801 27.2598 20.3836 27.3518 20.2707 27.4195C20.1577 27.4873 20.0312 27.5292 19.9001 27.5421C19.769 27.555 19.6367 27.5388 19.5127 27.4944C19.3887 27.4501 19.276 27.3788 19.1829 27.2857L15.6204 23.7232C15.4631 23.5543 15.3774 23.331 15.3815 23.1003C15.3856 22.8696 15.479 22.6494 15.6422 22.4862C15.8054 22.3231 16.0255 22.2296 16.2563 22.2255C16.487 22.2215 16.7103 22.3071 16.8791 22.4644L19.6733 25.2586L25.0088 17.2549C25.14 17.0585 25.3438 16.9224 25.5754 16.8763C25.807 16.8302 26.0474 16.8779 26.2438 17.0091Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </li>
          </div>
          <li style="clear: both"></li>
        </ul>
      </div>
      <div class="show-btn" v-if="rechargeAisle && rechargeAisle.length > 3">
        <p v-if="showMore" @click="showMore = !showMore">收起<van-icon name="arrow-up" /></p>
        <p v-else @click="showMore = !showMore">展开<van-icon name="arrow-down" /></p>
      </div>
    </div>
    <div class="deposit-money" v-if="payWay && usrAisle">
      <div class="title">充值金额</div>
      <div>
        <div class="input_money" v-if="usrAisle && usrAisle.allow_custom_amount == 1">
          <van-field v-model="frm.amount" type="digit" :placeholder="'限额 ' + payWay.min_price + '-' + payWay.max_price" @input="changeInputAmount">
            <template #right-icon>
              <span>元</span>
            </template>
          </van-field>
        </div>
        <div class="input-error" v-if="usrAisle && usrAisle.allow_custom_amount == 1 && showError">
          <van-icon name="info-o" />&nbsp;充值金额 {{ this.frm.amount > this.payWay.max_price ? '最多'+this.payWay.max_price : this.frm.amount < this.payWay.min_price ? '至少'+this.payWay.min_price : '' }} 元
        </div>
        <div class="select_money" v-if="usrAisle && usrAisle.need_fixed_amount == 1">
          <ul class="deposit-money-box">
            <div v-for="(item, index) in usrAisle.fixed_amounts" :key="index">
              <li class="money-item" :class="amountIndex == index ? 'money-item-select' : ''" @click="changeAmount(item, index)">{{ item }}</li>
            </div>

            <li style="clear: both"></li>
          </ul>
        </div>
      </div>
      <div class="rate" v-if="payWay && payWay.rate && payWay.rate > 0">
        <div class="rate-info">
          参考汇率 <span>1 {{ payWay.name }} ≈ 1CNY </span>
        </div>
        <div class="rate-money">
          交易数量 <span>{{ frm.amount && frm.amount.length && !isNaN(frm.amount) ? frm.amount / payWay.rate : 0 }}</span> {{ payWay.name }}
        </div>
      </div>
      <div style="clear: both;" />
      <div class="desc">注意：请以实际支付的汇率为准，到账金额为提交订单时的RMB金额</div>
    </div>
    <div class="deposit-btn-box">
      <div class="btn" @click="toRecharge">
        下一步
      </div>
      <p>
        存款遇到问题？联系<span style="color: #cca352;" @click="$parent.goNav('/myNews')">在线客服</span>处理
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'deposit',
  data () {
    return {
      payWayList: [],
      indexTab: null,
      payWay: null,
      rechargeAisle: [],
      indexAisle: null,
      usrAisle: null,
      showMore: false,

      frm: {
        aisle_id: null,
        amount: null,
      },
      showError: false,
      amountIndex: null,
    };
  },
  created () {
    let that = this;
    that.gerRechargeType();
  },
  methods: {
    changeInputAmount(val){
      if(this.payWay && this.payWay.min_price && this.payWay.max_price && val && val.length > 0){
        this.showError = (val > this.payWay.max_price || val < this.payWay.min_price)
        return
      }
      this.showError = false
    },
    gerRechargeType () {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .get('/api/gerRechargeType', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.changeTab(that.payWayList[0], 0);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    gerRechargeAisle () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .get('/api/gerRechargeAisle', { recharge_type_id: that.payWay.id })
        .then(res => {
          if (res.code == 0) {
            that.rechargeAisle = res.data;
            that.changeAisle(res.data[0], 0);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changeTab (item, index) {
      this.indexTab = index;
      this.payWay = item;

      const that = this;
      this.$nextTick(() => {
        that.gerRechargeAisle();
      });
    },
    changeAisle (item, index) {
      this.indexAisle = index;
      this.usrAisle = item;
      this.amountIndex = null;
      this.frm = {
        aisle_id: item.id,
        amount: null,
      };
      this.showError = false;
    },
    changeAmount (item, index) {
      this.frm.amount = item;
      this.amountIndex = index;
      this.changeInputAmount(item)
    },
    doCopy (msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.style.position = 'fixed';
      cInput.style.bottom = '0';
      cInput.style.right = '0';

      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();

      document.execCommand('copy');

      this.$parent.showTost(1, '复制成功！');
    },
    toRecharge () {
      let that = this;
      if(!that.frm.aisle_id){
        that.$parent.showTost(0, '请选择充值方式！');
        return 
      }
      if(!that.frm.amount){
        that.$parent.showTost(0, '请填写或选择充值金额！');
        return 
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/recharge', this.frm)
        .then(res => {
          if (res.code == 0) {
              that.jumpUrl(res.data.pay_url)
              that.frm.amount = null
              that.amountIndex = null
          } else {
            that.$parent.showTost(0, res.msg);
            return
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    jumpUrl (url) {
      const _u = navigator.userAgent
      const ios = _u.indexOf('iPhone') > -1
      const iPad = _u.indexOf('iPad') > -1
      if (ios || iPad) {
        window.location.replace(url)
      } else {
        if (url.includes('https://')) {
          window.open(url)
        } else {
          window.location.href = url
        }
      }
    }
  },
  mounted () {
    let that = this;
  },
  updated () {
    let that = this;
  },
};
</script>
<style>
.deposit-box {
  padding: 10px;
  background: #282828;
}
.deposit-box > .van-grid > .van-grid-item > .van-grid-item__content {
  background-color: rgb(0, 0, 0, 0) !important;
  padding: 4px 4px;
}
.input_money > .van-field {
  background: rgb(0, 0, 0, 0) !important;
  border-bottom: 1px solid #ddd !important;
}
.input_money > .van-field > .van-field__value > .van-field__body > .van-field__control {
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
@import '../../../static/css/chunk-7f0f3200.8064035a.css';
@import '../../../static/css/chunk-1b70332d.c584f871.css';

.rechargeType {
  width: 100%;
  background: #141414;
  text-align: center;
  padding: 15px 5px 10px;
  border-radius: 11px;
  border: 1px solid #141414;
  position: relative;
}
.rechargeType-selected {
  border: 1px solid #cca352;
  color: #cca352;
}
.rechargeType img {
  width: 25px;
  height: 25px;
  border-radius: 6px;
}
.rechargeType p {
  margin: 4px 0 0;
}
.rechargeType span {
  color: red;
  font-size: 12px;
}
.rechargeType .selected {
  position: absolute;
  right: -1px;
  bottom: -4px;
}
.rechargeType .gift_info {
  position: absolute;
  background: red;
  color: #fff !important;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 8px;
  border-bottom-left-radius: 0px;
  top: -4px;
  right: 0px;
}
.deposit-box .recharge_desc {
  margin: 10px 0;
  color: red;
}
.deposit-aisle {
  margin: 10px 0;
  background: #282828;
  padding: 10px 15px;
}
.deposit-aisle .title {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  position: relative;
}
.deposit-aisle .title .loaddown {
  font-size: 14px;
  position: absolute;
  right: 10px;
  top: 0px;
}

.deposit-aisle .show-btn {
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #cca352;
  padding: 8px 0;
}
.deposit-aisle .deposit-aisle-box {
}
.deposit-aisle .deposit-aisle-box .aisle-item {
  width: 45%;
  background: #282828;
  text-align: center;
  padding: 5px 5px 3px;
  border-radius: 11px;
  border: 1px solid rgb(255 255 255 / 10%);
  position: relative;
  float: left;
  margin-right: 2%;
  margin-bottom: 5px;
  text-align: left;
  display: inline-flex;
}
.deposit-aisle .deposit-aisle-box .aisle-item-select {
  border-color: #cca352;
  color: #cca352;
}
.deposit-aisle .deposit-aisle-box .aisle-item .icon {
  margin-left: 5px;
}
.deposit-aisle .deposit-aisle-box .aisle-item .name {
  padding-left: 8px;
  height: 24px;
  line-height: 24px;
}
.deposit-aisle .deposit-aisle-box .aisle-item .selected {
  position: absolute;
  bottom: -4px;
  right: 0px;
}
.deposit-money {
  padding: 10px;
  background: #282828;
  margin-top: 10px;
}
.deposit-money .title {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  position: relative;
}
.deposit-money .select_money,
.deposit-money > .rate,
.deposit-money > .desc {
  margin: 10px 0;
}
.deposit-money > .rate > .rate-info{
  float: left;
  span{
    color: #cca352;
  }
}
.deposit-money > .rate > .rate-money{
  float: right;
  span{
    color: #cca352;
  }
}
.deposit-money .select_money .deposit-money-box .money-item {
  min-width: 80px;
  text-align: center;
  background: #282828;
  text-align: center;
  padding: 10px 12px;
  border-radius: 11px;
  border: 1px solid rgb(255 255 255 / 10%);
  position: relative;
  float: left;
  margin-right: 2%;
  margin-bottom: 5px;
}
.deposit-money .select_money .deposit-money-box .money-item-select {
  border-color: #cca352;
  color: #cca352;
}
.deposit-money .input-error{
  padding:  5px 10px;
  color: red;
}
.deposit-btn-box {
  margin: 20px 10px 40px;
  text-align: center;
}
.deposit-btn-box .btn{
  text-align: center;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background: linear-gradient(#cca352, #cbb788);
}
.deposit-btn-box p {
  margin-top: 40px;
  margin-bottom: 20px;
}




.JoiHTIGs {
  display: flex;
  justify-items: center;
  flex-wrap: wrap;
}
._1lgxzaTd.VnPYo1MB {
  cursor: pointer;
}

.JoiHTIGs ._3jiVkBQ9 {
  // margin-right: 20px;
  margin-bottom: 20px;
}
._1lgxzaTd {
  width: 100%;
  height: 120px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  background-image: url(/static/image/bg2.c14d2591.png);
}
.bottom-slide-enter-active[data-v-5742baa6],
.bottom-slide-leave-active[data-v-5742baa6] {
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bottom-slide-enter[data-v-5742baa6],
.bottom-slide-leave-to[data-v-5742baa6] {
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
}
.dialog-content[data-v-5742baa6] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9950;
  width: 100%;
  height: auto;
}
.dialog-cover[data-v-5742baa6] {
  z-index: 9940;
}
.authorization[data-v-2b97710c],
.dialog-cover[data-v-5742baa6] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.authorization[data-v-2b97710c] {
  z-index: 999999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.authorization .content[data-v-2b97710c] {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background: #fff;
  width: 315px;
}
.authorization .content .close[data-v-2b97710c] {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 15px;
  right: 15px;
  margin: auto;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAABGdBTUEAALGPC/xhBQAAAh5JREFUWAm1lYlxwjAQRTE0xEAVSbogKStJF5k0gQ0NgbN/46/RsbpM4hmQvMfbr5Vlb+Z5HjbxdT6fZ9g4qt+8CYwIC3iNN4qXvwS28BI7DGD7ji0pLDoMgy6CdpXmZziHTNR+uVyefaM/V984jh/4+Q7MqUftcZDvdK0mRcSejsfjNhFLLAMVLX9umcAiE444KBS0BDBIu2bVdAFY6+12+xJRnxL4ihK1C10XwD2IAxE6SQ6cyw330W9TEmeBSomuzzEJIPScdqsP8Lk2MxAjKjIZvYFtmqZ3jMWrJNVamoOVEl3QMklA2MZiV2NCBNoAAAWZuKyZee585rpsEbhDu93uxR3Z1mUkPUCF1iaayZRYgxSTa5Cm5ByklmxuH5Yjie64lo66eRbwwuIZgLLD4fBGhfFoAiBbVJwIgRqoipPN+3jNtd0JIHEynU2QXHITpJZchLQm5yB6Gkv7zER/RE+k8B2nceB3AQEAYc9lDL+yfvYDcxTGu1VGfVmrgNj4H0KKNbigYtDKjrQwk9PRkkTRubGHkQggtAfySE5WQA90jVjyqwIYmCsCv/j0qca89yQ1CwAclyUE9t7CyMHVJSBX/Be1TkSTAKswV4zi/ssF9/TJWH2hFQWUCsfwnliI5GUKWAsDtDc3ENCbzFVYYytLBbQGW4Vqtho7+BoC1vMA1Yr7fkuI+xper9cnBO/3++/44fIhfzGHEL/eD8H/cjgqcbjmAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
}
.authorization .content .content-box[data-v-2b97710c] {
  padding: 40px 20px 20px;
}
.authorization .content .content-box .kyberbit[data-v-2b97710c] {
  height: 50px;
}
.authorization .content .content-box h3[data-v-2b97710c] {
  color: #333;
  font-size: 18px;
  margin-top: 3px;
  margin-bottom: 2px;
}
.authorization .content .content-box p[data-v-2b97710c] {
  color: #666;
  margin-top: 4px;
}
.authorization .content .content-box .logo-box[data-v-2b97710c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 16px;
  background: #eef0f5;
  padding: 15px;
  border-radius: 4px;
}
.authorization .content .content-box .logo-box img[data-v-2b97710c] {
  display: block;
  width: 50px;
  margin-right: 10px;
}
.authorization .content .content-box .logo-box span[data-v-2b97710c] {
  display: block;
  color: #333;
  margin-top: 5px;
}
.authorization .content .btn-box[data-v-2b97710c] {
  margin-top: 15px;
}
.authorization .content .btn-box .btn[data-v-2b97710c] {
  border-radius: 4px;
  color: #cca352;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.authorization .content .btn-box .btn.active[data-v-2b97710c] {
  background: #cca352;
  color: #fff;
}
.differentDepositTip[data-v-74a3466c] {
  width: 100%;
  padding: 0 0.13rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-image: -webkit-gradient(linear, left top, right top, from(#fa471d), color-stop(52%, #8900d3), to(#60f));
  background-image: linear-gradient(90deg, #fa471d, #8900d3 52%, #60f);
}
.differentDepositTip .item[data-v-74a3466c] {
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 0.35rem;
}
.differentDepositTip .item .item-left[data-v-74a3466c],
.differentDepositTip .item[data-v-74a3466c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.differentDepositTip .item .item-left[data-v-74a3466c] {
  font-size: 0.13rem;
  color: #fff;
  font-weight: 500;
}
.differentDepositTip .item .item-left img[data-v-74a3466c] {
  width: 0.16rem;
  height: 0.16rem;
}
.differentDepositTip .item .item-left span[data-v-74a3466c] {
  margin-left: 0.05rem;
}
.differentDepositTip .item .item-right[data-v-74a3466c] {
  font-size: 0.13rem;
  color: #fff;
  font-weight: 400;
  border: 1px solid #fff;
  border-radius: 4px;
  width: 0.6rem;
  height: 0.22rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.differentDepositTip .item .item-right img[data-v-74a3466c] {
  margin-left: 0.02rem;
  display: block;
  margin-top: 0.03rem;
}
.differentDepositTip.depositBottom[data-v-74a3466c] {
  background: #212121;
  border-radius: 0.04rem;
  margin-top: 0.1rem;
}
.differentDepositTip.depositBottom .item[data-v-74a3466c] {
  height: 0.4rem;
}
.differentDepositTip.depositBottom .item .item-left[data-v-74a3466c] {
  color: #ffcb4c;
}
.differentDepositTip.depositBottom .item .item-left img[data-v-74a3466c] {
  width: 0.26rem;
  height: 0.22rem;
  margin-top: 0.06rem;
}
.differentDepositTip.depositBottom .item .item-left span[data-v-74a3466c] {
  margin-left: 0;
}
.differentDepositTip.depositBottom .item .item-right[data-v-74a3466c] {
  border: none;
  color: #ffcb4c;
}
.differentDepositTip.depositSidBar[data-v-74a3466c] {
  background-image: -webkit-gradient(linear, left top, right top, color-stop(34%, #fa471d), to(#8b1ae5));
  background-image: linear-gradient(90deg, #fa471d 34%, #8b1ae5);
}
.protocolPopUp[data-v-26c8fc86] {
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.protocolPopUp .title[data-v-26c8fc86],
.protocolPopUp[data-v-26c8fc86] {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}
.protocolPopUp .title[data-v-26c8fc86] {
  height: 0.4rem;
  font-size: 16px;
  color: #333 !important;
  font-weight: 600;
}
.protocolPopUp .title .close[data-v-26c8fc86] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  width: 0.12rem;
  height: 0.12rem;
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
}
.protocolPopUp .content[data-v-26c8fc86] {
  overflow: hidden;
  width: 100%;
  height: calc(100% - 0.4rem);
  overflow-y: auto;
}
.protocolPopUp .content img[data-v-26c8fc86] {
  max-width: 100%;
  height: auto;
  margin-top: 0.1rem;
}
.scan__qr img {
  width: 100%;
  height: 100%;
}
.mt125[data-v-71669d2d] {
  margin-top: 125px !important;
}
.c-yellow[data-v-71669d2d] {
  color: #cca352;
}
.protocol-box .sub-tips[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0.2rem 0 0.1rem 0;
  font-size: 0.16rem;
  color: #fff;
}
.protocol-box .sub-tips img[data-v-71669d2d] {
  width: 0.14rem;
  height: 0.14rem;
  margin-left: 0.03rem;
}
.protocol-box .dcbox-protocol[data-v-71669d2d] {
  height: 45px;
  background: #282828;
  border-radius: 4px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 0.55rem;
  margin-bottom: 0.15rem;
}
.protocol-box .dcbox-protocol .protocol-item[data-v-71669d2d],
.protocol-box .dcbox-protocol[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.protocol-box .dcbox-protocol .protocol-item .text[data-v-71669d2d] {
  font-size: 14px;
  color: #999;
  font-weight: 400;
}
.protocol-box .dcbox-protocol .protocol-item .circle[data-v-71669d2d] {
  width: 12px;
  height: 12px;
  border: 1px solid #999;
  border-radius: 50%;
  margin-right: 7px;
  position: relative;
}
.protocol-box .dcbox-protocol .protocol-item img[data-v-71669d2d] {
  width: 0.3rem;
  height: 0.16rem;
  margin-left: 0.05rem;
}
.protocol-box .dcbox-protocol .protocol-item.active .text[data-v-71669d2d] {
  font-size: 14px;
  color: #fff;
}
.protocol-box .dcbox-protocol .protocol-item.active .circle[data-v-71669d2d] {
  border: 1px solid #facb5c;
}
.protocol-box .dcbox-protocol .protocol-item.active .circle[data-v-71669d2d]:after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #facb5c;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.deposit .deposit-input-title[data-v-71669d2d] {
  margin: 20px 0 0;
  font-size: 0.16rem;
  color: #fff;
}
.deposit__amount-input-wrapper[data-v-71669d2d] {
  position: relative;
  margin-top: 0.1rem;
  width: 100%;
  height: 0.5rem;
  background: #212121;
  border-radius: 0.04rem;
}
.deposit__amount-unit[data-v-71669d2d] {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0;
  width: 0.5rem;
  height: 0.5rem;
  background: #333;
  border-radius: 4px;
  font-size: 0.16rem;
  color: #999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.deposit__amount-input[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 24px;
  line-height: 34px;
  color: #fff;
  background-color: transparent;
  border: none;
  outline: none;
  padding-left: 0.1rem;
}
.deposit__amount-input[data-v-71669d2d]::-webkit-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::-moz-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]:-ms-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::-ms-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__cny-tips[data-v-71669d2d] {
  margin-top: 5px;
  font-size: 16px;
  line-height: 1;
  color: #999;
}
.deposit__content[data-v-71669d2d] {
  padding: 0 15px;
  overflow: hidden;
}
.deposit__title[data-v-71669d2d] {
  margin: 20px 0 15px;
  font-size: 16px;
  line-height: 18px;
  color: #fff;
}
.deposit__list[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 30px;
}
.deposit__item[data-v-71669d2d] {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  width: 33.33%;
  height: 80px;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
  text-align: center;
  vertical-align: top;
  background-color: #333;
  border: 1px solid transparent;
  border-radius: 5px;
}
.deposit__item + .deposit__item[data-v-71669d2d] {
  margin-left: 15px;
}
.deposit__item[data-v-71669d2d]:nth-child(3n + 1) {
  margin-left: -30px;
}
.deposit__item[data-v-71669d2d]:nth-child(n + 4) {
  margin-top: 15px;
}
.deposit__item.active[data-v-71669d2d] {
  background-color: #282828;
  border: 1px solid #cca352;
}
.deposit__item.amount[data-v-71669d2d] {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #ccc;
  border-radius: 4px;
}
.deposit .ylcb-tips[data-v-71669d2d] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 14px;
  background: url(/static/image/bank_tips.bb95242e.png) no-repeat;
  background-size: 100% 100%;
}
.deposit__icon[data-v-71669d2d] {
  width: 30px;
  height: 30px;
  margin-top: 15px;
  margin-bottom: 5px;
  vertical-align: top;
}
.deposit__button[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 45px;
  margin-top: 40px;
  font-size: 18px;
  line-height: 45px;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border: none;
  border-radius: 4px;
  outline: none;
}
.side[data-v-71669d2d] {
  background-color: #fff;
  border-radius: 4px 4px 0 0;
}
.side__header[data-v-71669d2d] {
  position: relative;
  height: 48px;
  font-size: 18px;
  line-height: 48px;
  color: #333;
  text-align: center;
  border-bottom: 1px solid #f4f4f4;
}
.side__close[data-v-71669d2d] {
  position: absolute;
  top: 50%;
  right: 15px;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAYAAADwbH0HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozRkU0Q0JGNUM1OTUxMUU2QTRCRDkzNUY1RDRCN0U4OCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozRkU0Q0JGNkM1OTUxMUU2QTRCRDkzNUY1RDRCN0U4OCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjNGRTRDQkYzQzU5NTExRTZBNEJEOTM1RjVENEI3RTg4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjNGRTRDQkY0QzU5NTExRTZBNEJEOTM1RjVENEI3RTg4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+ob5j0QAAArpJREFUeNq0l2uITGEYx88c24pNI7IfWPlA2RVbtEVbWLfWtc1lW7Fo48P6IhSJZElJUVKUSKz7Xe7rrohx+SCyqVVEyj1hy0rj99T/1GkyM2cu56nfzJme933+57097zORWCy2w3GcUpgNn5xwrRecgOcuH2UwFlqge4iiPeE6jIbBJlwHrTAUrkA0BNGoYpfDS9N0Nb3joQ2Gw3nomkfRIrgEFfBKWh9cOd9rut/ASDgHXfIgagO4AJXwTqL27bi+Rm99jnFwEgpzELW+p6FKAxsDrz2nm9C4TeIfYTIcgYIsRY9DtZZygmI7yYQdLb6Jf4YZcAA6ZSBqbQ9CDXyV6IvERm6Szs9gInzX+d4NkQCiFm8v1KqvxXiarGEye6KOP6ABdqYRN98umA/tMAUepXrDVPYApilQI2xN0XYbLFLbqXAv3dSkszswHX7DMtj4nzabYQl0wEy4FWRNgthVmKXAa2Ctz9cEK+WrU4ZKa5kcFUsEc+EobIBf6r8O/sI8OBs0WKZn1JLKAtgPW7Sh4rBQ5zawuVkkh0PC2+HNehEnbGE7LvV6jut5TtjCtUoQ1m8VrFCmatZudsJY4xqlQhNaryPkXXv2+7BS7MV8jrham6dQm6rJ57Mdvkm+U8rNeRGu0vVmgbdrehNttTJXZx2pUbkKV+r82oW+B5amaLtcudq7/EdkK1yhkqVIV2OjdnEyM99i2AfdlMGGZSpcrqozqnK0QdkpncV1URzzFXhDggqXqQztocKvPqCoZ176PKM62mINTCc8AK6pQ4vvYsjU/qiAuAzFEu+fTLgf3IQ+cFtnMhtRzzr04hazBG5A30ThEr2VOe77Lv9crV2x7voG1tsTLtb02jQ/hknwM48FvVeRPPQvpasdWJpQ4OXb/IXfINMskGBEF8CXEP+0fVM6tYG2/hNgAG/Bn4Gw4bZqAAAAAElFTkSuQmCC)
    no-repeat 50%;
}
.side__content[data-v-71669d2d] {
  min-height: 200px;
  max-height: 580px;
  padding: 0 15px;
  overflow: auto;
}
.gold[data-v-71669d2d],
.scan[data-v-71669d2d] {
  padding-bottom: 15px;
}
.gold__amount[data-v-71669d2d],
.scan__amount[data-v-71669d2d] {
  height: 54px;
  font-size: 16px;
  line-height: 54px;
  color: #666;
  border-bottom: 1px solid #ddd;
}
.gold__amount-number[data-v-71669d2d],
.scan__amount-number[data-v-71669d2d] {
  float: right;
  color: #333;
}
.gold__title[data-v-71669d2d],
.scan__title[data-v-71669d2d] {
  margin-top: 15px;
  font-size: 15px;
  line-height: 21px;
  color: #333;
  text-align: center;
}
.gold__subtitle[data-v-71669d2d],
.scan__subtitle[data-v-71669d2d] {
  font-size: 13px;
  line-height: 18px;
  color: #999;
  text-align: center;
}
.gold__crc[data-v-71669d2d],
.scan__crc[data-v-71669d2d] {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-bottom: -8px;
  margin-top: 5px;
}
.gold__qrwrap[data-v-71669d2d],
.scan__qrwrap[data-v-71669d2d] {
  position: absolute;
  width: 150px;
  height: 150px;
  margin-top: 15px;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.gold__qrwrap .crc2[data-v-71669d2d],
.scan__qrwrap .crc2[data-v-71669d2d] {
  position: absolute;
  opacity: 0.3;
  background: #000;
  right: 0;
  bottom: 9px;
  color: #fff;
  z-index: 2;
  font-size: 12px;
  padding: 2px 1px;
}
.gold__qr[data-v-71669d2d],
.scan__qr[data-v-71669d2d] {
  width: 150px;
  height: 150px;
  margin: 15px auto;
  font-size: 0;
}
.gold__qr img[data-v-71669d2d],
.scan__qr img[data-v-71669d2d] {
  width: 130px;
  height: 130px;
}
.gold__protocol[data-v-71669d2d],
.scan__protocol[data-v-71669d2d] {
  width: 1.5rem;
  height: 0.24rem;
  line-height: 0.24rem;
  background: #000;
  border-radius: 0.12rem;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  letter-spacing: 0;
  font-weight: 500;
  font-size: 0.14rem;
  padding: 0 0.1rem;
}
.gold__protocol .ex-change[data-v-71669d2d],
.scan__protocol .ex-change[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffcb4c;
  font-weight: 400;
  margin-left: 0.05rem;
}
.gold__protocol .ex-change img[data-v-71669d2d],
.scan__protocol .ex-change img[data-v-71669d2d] {
  width: 0.12rem;
  height: 0.12rem;
  margin-left: 0.03rem;
}
.gold .small-gold[data-v-71669d2d],
.scan .small-gold[data-v-71669d2d] {
  margin-top: -0.1rem;
}
.gold .tip-list[data-v-71669d2d],
.scan .tip-list[data-v-71669d2d] {
  font-size: 0.12rem;
  color: #999;
  font-weight: 500;
  margin-top: 0.15rem;
}
.gold .tip-list span[data-v-71669d2d],
.scan .tip-list span[data-v-71669d2d] {
  color: #cca452;
}
.gold__link[data-v-71669d2d],
.scan__link[data-v-71669d2d] {
  position: relative;
  height: 35px;
  padding-right: 70px;
  margin-top: 5px;
  overflow: hidden;
  font-size: 14px;
  line-height: 35px;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #f5f5f5;
  border-radius: 4px;
}
.gold__copy[data-v-71669d2d],
.scan__copy[data-v-71669d2d] {
  position: absolute;
  top: 0;
  right: 0;
  width: 70px;
  height: 100%;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border-radius: 4px;
}
.gold__tips[data-v-71669d2d],
.scan__tips[data-v-71669d2d] {
  margin-top: 15px;
  font-size: 12px;
  line-height: 17px;
  color: #999;
}
.gold__button[data-v-71669d2d],
.scan__button[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  margin-top: 20px;
  font-size: 18px;
  line-height: 48px;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border: none;
  border-radius: 4px;
  outline: none;
}
.scan[data-v-71669d2d] {
  position: relative;
}
.gold__img[data-v-71669d2d] {
  width: 100%;
  height: auto;
  margin-top: 20px;
  vertical-align: top;
}
.exchange[data-v-71669d2d] {
  padding-bottom: 15px;
  padding-left: 15px;
}
.exchange__item[data-v-71669d2d] {
  position: relative;
  display: inline-block;
  width: 50%;
  margin-top: 15px;
  overflow: hidden;
  text-align: center;
  vertical-align: top;
  background-color: #f5f5f5;
  border-radius: 6px;
}
.exchange__item[data-v-71669d2d]:nth-child(odd) {
  margin-right: 15px;
  margin-left: -15px;
}
.exchange__item .logo-link[data-v-71669d2d] {
  display: inline-block;
  width: 100%;
}
.exchange__icon[data-v-71669d2d] {
  width: 100%;
  height: 115px;
  vertical-align: top;
}
.exchange__link[data-v-71669d2d] {
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  color: #333;
  background-color: #eee;
}
.exchange__icon-hot[data-v-71669d2d] {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  background: -webkit-gradient(linear, left top, right top, from(#2ee6c7), to(#4d88ff));
  background: linear-gradient(90deg, #2ee6c7, #4d88ff);
  border-radius: 0 6px 0 6px;
}
.banner-wrap[data-v-71669d2d] {
  width: 100%;
  position: absolute;
  bottom: 20px;
  padding: 0 15px;
}
.banner-wrap .page__banner[data-v-71669d2d] {
  position: relative;
}
.banner-wrap .page__banner-img[data-v-71669d2d] {
  width: 100%;
  height: auto;
  vertical-align: top;
}
.banner-wrap .page__text-button-guide[data-v-71669d2d] {
  z-index: 2;
  position: absolute;
  width: 88px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  left: 50%;
  top: 34px;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  border-radius: 15px;
}
.banner-wrap .page__text-button-reg[data-v-71669d2d] {
  position: absolute;
  left: 0;
  width: 40%;
  height: 100%;
}
.banner-wrap .page__text-button-reg .btn[data-v-71669d2d] {
  position: absolute;
  color: #fff;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.banner-wrap .page__text-button-download[data-v-71669d2d] {
  position: absolute;
  right: 0;
  width: 40%;
  height: 100%;
}
.banner-wrap .page__text-button-download .btn[data-v-71669d2d] {
  position: absolute;
  color: #fff;
  right: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.banner-wrap .page__full-tips[data-v-71669d2d] {
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  text-align: center;
}
.no-data-notice[data-v-71669d2d] {
  margin-top: 60px;
  text-align: center;
}
.guide[data-v-71669d2d] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
}
.guide__button[data-v-71669d2d] {
  position: absolute;
  left: 50%;
  bottom: 100px;
  width: 162px;
  padding: 5px 0;
  margin-left: -81px;
  font-size: 14px;
  color: #cca352;
  text-align: center;
  background-color: #000;
  border: 1px solid #996b3d;
  border-radius: 4px;
  outline: none;
}
.guide__title[data-v-71669d2d] {
  margin-top: 75px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: #f3b663;
  text-align: center;
}
.guide__subtitle[data-v-71669d2d] {
  margin-top: 18px;
  font-size: 15px;
  line-height: 1;
  color: #fff;
  text-align: center;
}
.guide__subtitle + .guide__subtitle[data-v-71669d2d] {
  margin-top: 10px;
}
.guide__img[data-v-71669d2d] {
  width: 100%;
  height: auto;
}
.guide__cny-img[data-v-71669d2d] {
  width: 252px;
  height: auto;
  margin-top: 16px;
}
.guide__usdt-img[data-v-71669d2d] {
  width: 278px;
  height: auto;
  margin-top: 48px;
}
.guide__usdt-img.img1[data-v-71669d2d] {
  margin-top: 70px;
}
.guide__close[data-v-71669d2d] {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
}
.guide__cny-arrow[data-v-71669d2d] {
  position: absolute;
  bottom: 90px;
  left: 40px;
  width: auto;
  height: 150px;
}
.guide__usdt-arrow[data-v-71669d2d] {
  position: absolute;
  top: 42px;
  left: 76px;
  width: 35px;
  height: auto;
}
.guide__usdt-arrow1[data-v-71669d2d] {
  position: absolute;
  top: 128px;
  left: 76px;
  width: 78px;
  height: auto;
}
.kyberbit-guide-button[data-v-71669d2d] {
  position: fixed;
  right: 10px;
  bottom: 92px;
  z-index: 10;
  width: 50px;
  height: 50px;
  background-image: url(/static/image/btn-entrance.36d47e44.png);
  background-size: 100% 100%;
}
.showPopupTxt[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #cca352;
  text-decoration: underline;
  margin-top: 20px;
}
.protocolPopUp .title[data-v-26c8fc86][data-v-1b127c58] {
  height: 1.4rem;
  font-size: 16px;
  color: #333 !important;
  font-weight: 600;
}
.protocolPopUp .title .close[data-v-26c8fc86][data-v-1b127c58] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  width: 0.42rem;
  height: 0.42rem;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/main/deposit.vue